<template>
  <router-view/>
</template>

<script>
  import RouteEntryMixin from '@com/mixins/route-entry'

  export default {
    name: 'sales',
    mixins: [RouteEntryMixin],
    data: _ => ({
      routes: [
        { path: '/sales/explore', label: 'Explore' }
      ]
    })
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/vue/app/sales/Sales.Entry.vue